export const initialState = {
  error: null,
  data: null,
}
